import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dotmedy_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => {
    const m = (r.config?.method || "").toLowerCase();
    if ((m === "post" || m === "put") && !(r.config?.url || "").includes("/dotcoins")) {
      window.dispatchEvent(new Event("dotcoins:check"));
    }
    return r;
  },
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith("/app")) {
        localStorage.removeItem("dotmedy_token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
